import { render, staticRenderFns } from "./SavedTripCarousel.vue?vue&type=template&id=f7da9658"
import script from "./SavedTripCarousel.vue?vue&type=script&lang=ts"
export * from "./SavedTripCarousel.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports